const eventNamespace = 'worker_marketing_preferences_modal'

export const trackingEvents = {
  CONSENT: `${eventNamespace}.consent_confirm.clicked`,
}
